import { memo } from "react";

import LoadingIcon from "components/Loading";

const FullSizeLoading = memo(() => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <LoadingIcon />
    </div>
  );
});

FullSizeLoading.displayName = "FullSizeLoading";

export default FullSizeLoading;
